/* TAKUMIBA お気に入り機能 v4（トースト通知つき）
 * 保存先: localStorage（ログイン不要 / 端末ごとに保存）
 * 公開API: window.Favorites.{all, has, toggle, remove, clear, count}
 */
(function () {
  'use strict';

  var KEY = 'takumiba_favorites_v1';
  var LIST_URL = '/pages/favorites';
  var TOAST_MS = 4000;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function write(list, meta) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* プライベートブラウジング等で保存不可 */
    }
    var detail = meta || {};
    detail.list = list;
    document.dispatchEvent(new CustomEvent('favorites:updated', { detail: detail }));
  }

  var Favorites = {
    all: read,
    count: function () {
      return read().length;
    },
    has: function (handle) {
      return read().indexOf(handle) > -1;
    },
    toggle: function (handle) {
      var list = read();
      var i = list.indexOf(handle);
      var added;
      if (i > -1) {
        list.splice(i, 1);
        added = false;
      } else {
        list.unshift(handle);
        added = true;
      }
      write(list, { action: added ? 'added' : 'removed', handle: handle });
      return added;
    },
    remove: function (handle, silent) {
      var list = read().filter(function (h) {
        return h !== handle;
      });
      write(list, silent ? {} : { action: 'removed', handle: handle });
    },
    clear: function () {
      write([], { action: 'cleared' });
    }
  };

  window.Favorites = Favorites;

  /* ---- トースト通知 ---- */

  var toastEl = null;
  var toastTimer = null;

  function buildToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.className = 'fav-toast';
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.hidden = true;
    toastEl.innerHTML =
      '<span class="fav-toast__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><path d="M12 20.5 4.2 13.1a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l1.3 1.3 1.3-1.3a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5Z" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '<span class="fav-toast__text"></span>' +
      '<a class="fav-toast__link" href="' + LIST_URL + '">一覧を見る</a>' +
      '<button type="button" class="fav-toast__close" aria-label="閉じる">&times;</button>';
    toastEl.querySelector('.fav-toast__close').addEventListener('click', hideToast);
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function hideToast() {
    if (!toastEl) return;
    toastEl.classList.remove('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.hidden = true;
    }, 250);
  }

  function showToast(action) {
    if (document.querySelector('[data-favorites-page]')) return;

    var el = buildToast();
    var text = el.querySelector('.fav-toast__text');
    var link = el.querySelector('.fav-toast__link');

    if (action === 'added') {
      text.textContent = 'お気に入りに追加しました';
      el.classList.add('is-added');
      link.hidden = false;
    } else if (action === 'removed') {
      text.textContent = 'お気に入りから外しました';
      el.classList.remove('is-added');
      link.hidden = Favorites.count() === 0;
    } else if (action === 'cleared') {
      text.textContent = 'お気に入りをすべて削除しました';
      el.classList.remove('is-added');
      link.hidden = true;
    } else {
      return;
    }

    clearTimeout(toastTimer);
    el.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-visible');
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  /* ---- 表示同期 ---- */

  function syncButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('.js-favorite-btn');
    if (!buttons.length) return;
    var list = read();
    buttons.forEach(function (btn) {
      var on = list.indexOf(btn.dataset.productHandle) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'お気に入りから外す' : 'お気に入りに追加';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      var text = btn.querySelector('.js-favorite-btn-text');
      if (text) text.textContent = on ? 'お気に入り済み' : 'お気に入り';
    });
  }

  function syncCount() {
    var n = Favorites.count();
    document.querySelectorAll('.js-favorite-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncAll() {
    syncButtons();
    syncCount();
  }

  /* ---- イベント ---- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.js-favorite-btn') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    Favorites.toggle(btn.dataset.productHandle);
  });

  document.addEventListener('favorites:updated', function (e) {
    syncAll();
    showToast(e.detail && e.detail.action);
  });

  window.addEventListener('pageshow', syncAll);

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncAll();
  });

  document.addEventListener('shopify:section:load', function (e) {
    syncButtons(e.target);
    syncCount();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();